import { rpc } from "#rpc";
import type { AsyncReturnType } from "@frend-digital/utils";
import type { GA4Product } from "@frend-digital/events/gtm";
import type { DepictOptions } from "@frend-digital/depict/server";

export const fetchProductsClientAction = async ({
	cache,
	depictCategory,
	depictOptions,
	showAsOnSale,
	parentHref,
	onlyAvailable,
	cursor,
}: {
	depictOptions: DepictOptions;
	depictCategory?: string;
	cache: boolean;
	showAsOnSale?: boolean;
	parentHref?: string;
	onlyAvailable?: boolean;
	cursor?: string;
}) => {
	const result = await rpc.depict.getProductList({
		cache,
		depictCategory,
		depictOptions,
		showAsOnSale,
		parentHref,
		onlyAvailable,
		cursor,
	});

	return {
		sorts: result.sorts,
		filter: result.filter,
		nextCursor: result.nextCursor,
		total: result.total,
		categoryUUID: depictCategory,
		gtmProducts: result?.products?.map((product): GA4Product => {
			return {
				item_id: product.sku,
				price: product.priceAsNumber!,
				item_name: product.name,
				quantity: 1,
			};
		}),

		products: result.products,
	};
};

export type ProductListData = AsyncReturnType<typeof fetchProductsClientAction>;

export type Filter = Awaited<ReturnType<typeof fetchProductsClientAction>>["filter"];
